import { styled } from "@mui/material/styles";
import { DialogContent as MuiDialogContent, Grid, Typography } from "@mui/material";

export const DialogContent = styled(MuiDialogContent)({
  display: "flex",
  alignItems: "center",
  gap: "30px",
  marginTop: "-20px",

  ".MuiButton-root": {
    height: "40px",
    fontSize: "1.3em",
    textTransform: "none",
  },
});

export const TextMessage = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  color: theme.palette.text.primary,
  fontWeight: "bold",
}));

export const InfoContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  fontSize: "1rem",
  color: theme.palette.text.primary,
  fontWeight: "bold",

  "& .info > .info_description": {
    color: "rgba(0, 0, 0, 0.65)",
    letterSpacing: "2px",
    fontStyle: "italic",
  },

  "& .info_day": {
    marginTop: "10px",
  },
}));

export const IntervalContainer = styled(Grid)({
  width: "300px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  color: "rgba(0, 0, 0, 0.65)",
  letterSpacing: "2px",
  fontStyle: "italic",
});
